import style from "css/hotdesking.module.css";
import { Button, Popup } from "antd-mobile";
import React, { useState } from "react";
import {
  CloseOutlined,
  RightOutlined,
  UnorderedListOutlined,
} from "@ant-design/icons";
import ShareTeam from "./ShareTeam";
import ShareFavorite from "./ShareFavorite";
import ShareCancel from "./ShareCancel";
import { Trans, useTranslation } from "react-i18next";

function BookShare({ book, isOpen, onClose, onError }) {
  const { t } = useTranslation();
  const [isOpenTeam, setIsOpenTeam] = useState(false);
  const [isOpenFavorite, setIsOpenFavorite] = useState(false);
  const [isOpenCancel, setIsOpenCancel] = useState(false);

  const options = [
    {
      label: (
        <Trans
          i18nKey="HOTDESKING.MODAL.SHARE.MY_TEAM.DESC"
          components={{ strong: <strong /> }}
        />
      ),
      title: t("HOTDESKING.MODAL.SHARE.MY_TEAM.TITLE"),
      type: "department",
    },
    {
      label: (
        <Trans
          i18nKey="HOTDESKING.MODAL.SHARE.FAVORITE.DESC"
          components={{ strong: <strong /> }}
        />
      ),
      title: t("HOTDESKING.MODAL.SHARE.FAVORITE.TITLE"),
      type: "favorite",
    },
  ];

  const onOpenPopup = (type) => {
    switch (type) {
      case "favorite":
        onOpenFavorite();
        break;
      case "department":
        onOpenTeam();
        break;
      default:
        break;
    }
  };

  const onOpenTeam = () => {
    setIsOpenTeam(true);
  };
  const onCloseTeam = () => {
    setIsOpenTeam(false);
  };
  const onOpenFavorite = () => {
    setIsOpenFavorite(true);
  };
  const onCloseFavorite = () => {
    setIsOpenFavorite(false);
  };
  const onOpenCancel = () => {
    setIsOpenCancel(true);
  };
  const onCloseCancel = () => {
    setIsOpenCancel(false);
  };
  return (
    <>
      <ShareTeam
        book={book}
        isOpen={isOpenTeam}
        onClose={onCloseTeam}
        onError={onError}
      />
      <ShareFavorite
        book={book}
        isOpen={isOpenFavorite}
        onClose={onCloseFavorite}
        onError={onError}
      />
      <ShareCancel
        book={book}
        isOpen={isOpenCancel}
        onClose={onCloseCancel}
        onError={onError}
      />
      <Popup
        className={`${style.popup} ${style.share}`}
        visible={isOpen}
        onMaskClick={onClose}
      >
        <section className={style.share_section}>
          <section className={style.share_header}>
            <p>{t("HOTDESKING.MODAL.SHARE.TITLE")}</p>
            <CloseOutlined className={style.header_icon} onClick={onClose} />
          </section>
          <section className={style.share_body}>
            {options.map((item, idx) => (
              <Button
                key={idx}
                className={style.share_item}
                onClick={() => onOpenPopup(item.type)}
              >
                <div className={style.item_content}>
                  <p className={style.item_title}>{item.label}</p>
                  <RightOutlined className={style.item_icon} />
                </div>
              </Button>
            ))}
          </section>
          <section className={style.share_footer} onClick={onOpenCancel}>
            <div className={style.footer_title}>
              <div className={style.footer_icon}>
                <UnorderedListOutlined />
              </div>
              <p>{t("HOTDESKING.MODAL.SHARE.SHARED.TITLE")}</p>
            </div>
            <RightOutlined className={style.footer_arrow} />
          </section>
        </section>
      </Popup>
    </>
  );
}

export default BookShare;
